import React from "react"
import autobind from "class-autobind"
import { Dialog, FlatButton, Toggle } from "material-ui"
import AccountStore from "../../../stores/AccountStore"
import HierarchySettingsStore from "../../../stores/HierarchySettingsStore"
import strings from "../../../localization/strings"
import { IPayrollPayCalendar, IDate, EExceptionType, IUserFilter } from "../../../models"
import moment from "moment"
import * as reportAction from "../../../actions/ReportAction"
import * as payrollHelper from "../../../helpers/payrollHelper"
import DateRangeSelect from "../../common/DateRangeSelect"

interface IProps {
    selectedPayrollPayCalendar: IPayrollPayCalendar
    userFilter: IUserFilter
    handleClose(): void

    // job->Timecard report
    jobId: string

    // Timecard page report
    filterByDefaultHierarchy: boolean
    filterDirectReportsOnly: boolean
    filterByPunchHierarchy: boolean
    filterByException: boolean
    filterExceptions: EExceptionType[]
}
interface IState {
    startDate: IDate
    endDate: IDate    
    errorDates: string
    //By default only include adds, edits, and deletes from GC users in the report AND mobile user timecard edits or Missing punch (suspense punches) from mobile users.
    includeAllAuditData: boolean
}

export default class TimecardAuditReportDialog extends React.Component<IProps, IState> {
    constructor(props) {
        super(props)
        const startDate = moment().add(-1, "month").utc(true)
        const endDate = moment().utc(true)
        this.state = {
            startDate,
            endDate,
            errorDates: "",
            includeAllAuditData: false
        }
        autobind(this)
    }

    checkValidate() {
        let isValidate = true
        if (moment(this.state.startDate).isAfter(this.state.endDate)) {
            this.setState({ errorDates: strings.Invalid_date_range })
            isValidate = false
        }
        else if (moment(this.state.startDate).add(1, "month").isBefore(this.state.endDate)) {
            this.setState({ errorDates: strings.Report_cannot_include_more_than_1_month_Please_change_your_selected_dates })
            isValidate = false
        }
        else {
            this.setState({ errorDates: "" })
        }
        return isValidate
    }

    handleRequestSave() {
        if (this.checkValidate()) {
            this.props.handleClose()
            const payGroupIds = payrollHelper.getPayGroupIdsByPayrollPayCalendar(this.props.selectedPayrollPayCalendar)
            this.props.jobId ?
                reportAction.downloadJobTimecardAuditReport(AccountStore.getCurrentAccount().Id, this.props.jobId, payGroupIds, this.props.userFilter, moment(this.state.startDate).utc(true).startOf("day").format(), this.state.includeAllAuditData, moment(this.state.endDate).utc(true).startOf("day").format()) :
                reportAction.downloadTimecardAuditReport(AccountStore.getCurrentAccount().Id, HierarchySettingsStore.getGlobalLevelItemFilterId(), payGroupIds, this.props.userFilter, moment(this.state.startDate).utc(true).startOf("day").format(), this.props.filterByDefaultHierarchy, this.props.filterDirectReportsOnly, this.props.filterByPunchHierarchy, this.props.filterByException, this.props.filterExceptions, this.state.includeAllAuditData, moment(this.state.endDate).utc(true).startOf("day").format())
        }
    }

    render() {
        return (
            <Dialog
                open
                title={strings.TimecardAuditReport}
                actions={[
                    <FlatButton data-intercom-target={"Timecards-Reports-Btn-CloseTimecardAuditReportDialog"} key="cancel" label={strings.CANCEL} secondary onTouchTap={this.props.handleClose} />,
                    <FlatButton data-intercom-target={"Timecards-Reports-Btn-DownloadTimecardAuditReport"} key="download" label={strings.Download} primary onTouchTap={this.handleRequestSave} />
                ]}
            >
                <DateRangeSelect
                    sameDatesAllowed
                    startDate={this.state.startDate}
                    endDate={this.state.endDate}
                    handleChange={(startDate, endDate) =>
                        this.setState({
                            startDate,
                            endDate
                        }, () => this.checkValidate())
                    }
                    errorEndDate={this.state.errorDates}
                />
                <Toggle
                    toggled={this.state.includeAllAuditData}
                    onToggle={(e, includeAllAuditData) => this.setState({ includeAllAuditData })}
                    labelPosition="left"
                    label={strings.Include_all_Audit_data}
                    style={{ maxWidth: 200, marginTop: 20 }}
                />
            </Dialog>
        )
    }
}
